import React, { Component } from 'react'
import { connect } from 'react-redux';
let RealHeaderAdminMenu = null;

class HeaderAdminMenu extends Component {
  	constructor(props) {
    	super(props);
    	this.state = { isReady: RealHeaderAdminMenu !== null };
  	}

  	componentDidMount() {
  		const {profile} = this.props
  		
  		if(!profile) return
  		this.load()
  	}
  	
	componentWillReceiveProps({profile}) {
		if(profile && !RealHeaderAdminMenu) this.load()
	}

  	load() {
    	require.ensure('./admin', () => {
      		RealHeaderAdminMenu = require('./admin').RealHeaderAdminMenu;
      		if (!this.hasUnmounted) {
        		this.setState({ isReady: true });
      		}
    	});
  	}

  	componentWillUnmount() {
    	this.hasUnmounted = true;
  	}

  	render() {
  		return this.state.isReady ? <RealHeaderAdminMenu/> : null;
  	}
}

export default connect(state => ({profile: state.auth.profile}))(HeaderAdminMenu);



// WEBPACK FOOTER //
// ./src/fm/admin/HeaderAdminMenu.js